<script lang="ts" setup>
import type { IProps } from './solutions-imageWithAccordeon.types'
import SolutionsUiAccordeon from '@/domains/solutions/solutions-UiAccordeon/solutions-UiAccordeon.vue'

defineProps<IProps>()

</script>

<template>
  <UiSection>
    <div class="image-with-accordeon">
      <UiHeader
        :header="header"
        :subheader="subheader"
        position="center"
      />

      <div class="image-with-accordeon__content">
        <img
          class="image-with-accordeon__image"
          :src="image"
        >
        <SolutionsUiAccordeon
          v-if="data"
          :data="data"
        />
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
.image-with-accordeon {
  $root: &;

  max-width: 115.2rem;
  width: 100%;
  margin: 0 auto;

  @include atXL {
    max-width: 134rem;
  }

  &__content {
    margin-top: 3.4rem;

    @include atM {
      display: flex;
      align-items: flex-start;
      gap: 9.2rem;
      margin-top: 8rem;

      #{$root}__image,
      .accordeon__list {
        width: 50%;
      }
    }
  }

  &__image {
    width: 100%;
    border-radius: 1.6rem;
  }
}
</style>
